import { Navigate, useLocation } from "react-router-dom";

export const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const isVerified = sessionStorage.getItem("isProtectionVerified") === "true";
  const location = useLocation();
  
  // Only allow /protect route when not verified
  if (!isVerified) {
    if (location.pathname !== '/protect') {
      return <Navigate to="/protect" replace state={{ from: location }} />;
    }
  }

  // If verified, don't allow accessing /protect again
  if (isVerified && location.pathname === '/protect') {
    return <Navigate to="/home" replace />;
  }

  return children;
};